<template>
  <div
    v-if="isOpen"
    class="bg-blue-100 flex flex-row max-w-4xl p-3 relative rounded w-full"
    role="alert"
  >
    <doe-icon icon="circleInformation" class="mr-3" />
    <div>
      <p
        class="font-sans font-semibold mb-0 text-lg text-blue-900 leading-tight"
      >
        {{ title }}
      </p>
      <p
        v-for="(description, index) in formatDescription"
        :key="index"
        class="font-sans mb-0 text-md text-blue-900 leading-tight"
      >
        {{ description }}
      </p>
    </div>
    <a class="cursor-pointer mx-3 absolute right-0" @click="toggleMenu()" v-show="closeable">
      <doe-icon icon="times" />
    </a>
  </div>
</template>

<script>
import DoeIcon from "@/components/icon/Icon";

export default {
  name: "DoeAlert",
  props: {
    title: {
      type: [Array, String],
      required: true
    },
    description: {
      type: [Array, String],
      required: false
    },
    closeable: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  components: {
    DoeIcon
  },
  data() {
    return {
      isOpen: true
    };
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    }
  },
  computed: {
    formatDescription() {
      if (!Array.isArray(this.description)) {
        return new Array(this.description);
      } else {
        return this.description;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
